import { render, staticRenderFns } from "./AddFileEvaluation.vue?vue&type=template&id=3e4f4d82&scoped=true&"
import script from "./AddFileEvaluation.vue?vue&type=script&lang=js&"
export * from "./AddFileEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./AddFileEvaluation.vue?vue&type=style&index=0&id=3e4f4d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f4d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFileInput,VIcon})
